var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehaviorHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF4646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4201 8.30494C16.1647 8.04944 15.8615 7.84676 15.5277 7.70848C15.194 7.5702 14.8363 7.49902 14.4751 7.49902C14.1138 7.49902 13.7561 7.5702 13.4224 7.70848C13.0887 7.84676 12.7854 8.04944 12.5301 8.30494L12.0001 8.83494L11.4701 8.30494C10.9542 7.78909 10.2546 7.49929 9.52506 7.49929C8.79554 7.49929 8.09591 7.78909 7.58006 8.30494C7.06421 8.82078 6.77441 9.52042 6.77441 10.2499C6.77441 10.9795 7.06421 11.6791 7.58006 12.1949L8.11006 12.7249L12.0001 16.6149L15.8901 12.7249L16.4201 12.1949C16.6756 11.9396 16.8782 11.6363 17.0165 11.3026C17.1548 10.9689 17.226 10.6112 17.226 10.2499C17.226 9.88869 17.1548 9.53099 17.0165 9.19726C16.8782 8.86353 16.6756 8.56031 16.4201 8.30494V8.30494Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorHeart);
export default __webpack_public_path__ + "static/media/behavior-heart.e50eb52acd430267a9345d1e42b31d37.svg";
export { ForwardRef as ReactComponent };